import { render, staticRenderFns } from "./PTplInfoForm.vue?vue&type=template&id=10637f64&"
import script from "./PTplInfoForm.vue?vue&type=script&lang=js&"
export * from "./PTplInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports